export default __webpack_public_path__ + "static/media/1.101a7e2f.webp";